import { Box } from "@mui/material";
import { Draggable } from "@hello-pangea/dnd";
import PolicySectionItem from "./PolicySectionItem";
import PolicySectionDragClone from "./PolicySectionDragClone";
import { PolicyControl, PolicySection } from "./PolicySections.types";
import { PolicySectionActions } from "./PolicySections.hooks";

export interface PolicySectionRowProps {
    section: PolicySection;
    index: number;
    actions: PolicySectionActions;
    isReordering: boolean;
    isEditable: boolean;
    availableControls: Array<PolicyControl>;
    createdSectionId: string | undefined;
    createdSubsectionId: string | undefined;
    isAddingSubsection: boolean;
    isAddingSectionAfter: boolean;
    isAddingSectionAfterSubsection: boolean;
    editingContentId: string | undefined;
    isVersionPreview: boolean;
}

function PolicySectionRow({
    section,
    index,
    actions,
    isReordering,
    isEditable,
    availableControls,
    createdSectionId,
    createdSubsectionId,
    isAddingSubsection,
    isAddingSectionAfter,
    isAddingSectionAfterSubsection,
    editingContentId,
    isVersionPreview,
}: PolicySectionRowProps) {
    return (
        <Draggable draggableId={section.id} index={index} isDragDisabled={!isReordering}>
            {(draggableProvided) =>
                isReordering ? (
                    <Box ref={draggableProvided.innerRef} {...draggableProvided.draggableProps} {...draggableProvided.dragHandleProps} sx={{ cursor: "grab" }}>
                        <PolicySectionDragClone numberLabel={`${index + 1}`} title={section.title} />
                    </Box>
                ) : (
                    <Box ref={draggableProvided.innerRef} {...draggableProvided.draggableProps}>
                        <PolicySectionItem
                            section={section}
                            index={index}
                            setFocusOnTitle={createdSectionId === section.id}
                            availableControls={availableControls}
                            readOnlyPreview={isVersionPreview}
                            disabled={!isEditable}
                            dragHandleProps={draggableProvided.dragHandleProps}
                            onTitleChange={(title) => actions.updateSectionTitle(section.id, title)}
                            onContentChange={(content) => actions.updateSectionContent(section.id, content)}
                            onLinkedControlsChange={(ids) => actions.setSectionControls(section.id, ids)}
                            onDelete={index === 0 ? undefined : () => actions.requestDeleteSection(section)}
                            createdSubsectionId={createdSubsectionId}
                            isAddingSubsection={isAddingSubsection}
                            isAddingSectionAfter={isAddingSectionAfter}
                            isAddingSectionAfterSubsection={isAddingSectionAfterSubsection}
                            onAddSubsection={(targetIndex) => actions.addSubsection(section.id, targetIndex)}
                            onAddSectionAfter={() => actions.addSectionAfter(section.id)}
                            onAddSectionAfterSubsection={(subsectionId) => actions.addSectionAfterSubsection(section.id, subsectionId)}
                            onSubsectionTitleChange={(subsectionId, title) => actions.updateSubsectionTitle(section.id, subsectionId, title)}
                            onSubsectionContentChange={(subsectionId, content) => actions.updateSubsectionContent(section.id, subsectionId, content)}
                            onSubsectionLinkedControlsChange={(subsectionId, ids) => actions.setSubsectionControls(section.id, subsectionId, ids)}
                            onSubsectionDelete={(subsection) => actions.setSubsectionForDeletion({ sectionId: section.id, subsection })}
                            editingContentId={editingContentId}
                            startEditingContent={actions.startEditingContent}
                        />
                    </Box>
                )
            }
        </Draggable>
    );
}

export default PolicySectionRow;
